module.exports = __webpack_public_path__ + "static/media/shelter.364b1d98.svg";